module.exports = __webpack_public_path__ + "static/media/icon-parking.1c17db16.svg";